// src/components/dashboard/JobLayout.tsx
// @ts-nocheck
import React, { useEffect, useRef, useState } from 'react';
import Sidebar from './Sidebar';
import { ReactNode } from 'react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { useAppDispatch, useAppSelector } from '../../app/hooks';
import { RootState } from '../../app/store';
import { motion, AnimatePresence } from 'framer-motion';
import { Listbox, ListboxButton, ListboxOptions, Switch, Transition } from '@headlessui/react'
import { CrossIcon1 } from '../icons/Icons';
import { Currency, EducationTypeOption, ExperienceTypeOption, JobLayoutProps, JobTypeOption, Location, SalaryDurationType, StatusType, Tags, WorkingTypeOption } from './jobType';
import currencyData from '../../utils/currencyData';
import { setAsideOpen, toggleAside } from '../../features/job/layoutSlice';
import { fetchDocument, updateDocument } from '../../features/job/jobSlices';
import { toast } from 'sonner';
import { useEditorContext } from '../../context/EditorContext';
import { useJobApplicationContext } from '../application/JobApplicationContext';
import { fetchLocationList } from '../../features/location/locationSlice';




const locations: Location[] = [
  { id: 1, name: 'India' },
  { id: 2, name: 'USA' },
  { id: 3, name: 'Algeria' },
  { id: 4, name: 'Australia' }
];


const jobTypeOptions: JobTypeOption[] = [
  { id: 1, name: 'Full-Time', label: '#1d4ed8', nlabel: 'Full_Time' }, // Blue
  { id: 2, name: 'Part-Time', label: '#15803d', nlabel: 'Part_Time' }, // Green
  { id: 3, name: 'Contract', label: '#854d0e', nlabel: 'Contract' }, // Amber/Yellow
  { id: 4, name: 'Temporary', label: '#b91c1c', nlabel: 'Temporary' }, // Red
  { id: 5, name: 'Internship', label: '#7e22ce', nlabel: 'Internship' }, // Teal
  { id: 6, name: 'Volunteer', label: '#4b5563', nlabel: 'Volunteer' }, // Gray
  { id: 7, name: 'Other', label: '#343A40', nlabel: 'Other' }, // Dark Gray
];


const wokringTypeOptions: WorkingTypeOption[] = [
  { id: 1, name: 'On-site', label: '#16a34a33', icon: '#15803d', nlabel: 'On_site' }, // Green
  { id: 2, name: 'Hybrid', label: '#1d4ed81a', icon: '#1d4ed8', nlabel: 'Hybrid' }, // blue
  { id: 3, name: 'Remote', label: '#ca8a0433', icon: '#854d0e', nlabel: 'Remote' }, // Amber/Yellow
];



const educationTypeOptions: EducationTypeOption[] = [
  { id: 1, name: 'Unspecified', label: 'Unspecified' },
  { id: 2, name: 'High School', label: 'High_School' },
  { id: 3, name: 'Pursuing Degree', label: 'Pursuing_Degree' },
  { id: 4, name: 'Associate', label: 'Associate' },
  { id: 5, name: "Bachelor's", label: 'Bachelors' },
  { id: 6, name: "Master's", label: 'Masters' },
  { id: 7, name: 'PhD', label: 'PhD' },
  { id: 8, name: 'Other', label: 'Other' },
];

const experienceTypeOptions: EducationTypeOption[] = [
  { id: 1, name: 'Intern' },
  { id: 2, name: 'Entry Level (0 - 2  years)' },
  { id: 3, name: 'Mid (3 - 7 years)' },
  { id: 4, name: 'Senior (8 - 12 years)' },
  { id: 5, name: "Executive (15+ years)" }
];


const SalaryTypeOptions: SalaryDurationType[] = [
  { id: 1, name: 'Yearly' },
  { id: 2, name: 'Monthly' },
  { id: 3, name: 'Weekly' },
  { id: 4, name: 'Daily' },
  { id: 4, name: 'Hourly' }
];



const StatusTypeOptions: StatusType[] = [
  { id: 1, name: 'active', label: '#16a34a33', icon: '#15803d' }, // Green
  { id: 2, name: 'deleted', label: '#dc26261a', icon: '#b91c1c' }, // blue
  { id: 3, name: 'archived', label: '#ca8a0433', icon: '#854d0e' }, // Amber/Yellow
  { id: 4, name: 'draft', label: '#6b72801a', icon: '#4b5563' }, // Green
  { id: 5, name: 'close', label: '#be185d1a', icon: '#be185d' }
];

const IntakeTypeOptions: StatusType[] = [
  { id: 1, name: 'Public' }, // Green
  { id: 2, name: 'Company' }, // blue
  { id: 3, name: 'Unlisted' }, // Amber/Yellow
  { id: 4, name: 'Manual' }, // Green
];

const tagsTypeOptions: Tags[] = [
  { id: 1, name: 'One' },
  { id: 2, name: 'Two' },
  { id: 3, name: 'Three' },
  { id: 4, name: 'Four' },
  { id: 4, name: 'Five' }
];


const JobLayout: React.FC<JobLayoutProps> = ({ children }) => {
  const { baseId } = useParams<{ baseId: string }>(); // Extract baseId from URL
  const [userDetails, setUserDetails] = useState<any>(null);
  const bases = useAppSelector((state: RootState) => state?.base?.data?.data?.bases);
  // const [isAsideOpen, setIsAsideOpen] = useState(true);
  const [isHovered, setIsHovered] = useState(false);
  const [collapsed, setCollapsed] = useState(false);
  const [location, setLocation] = useState<Location>(null);
  const [selectedLocations, setSelectedLocations] = useState<Location[]>([]);
  const [selectedJobType, setSelectedJobType] = useState<JobTypeOption | null>(null);
  const [selectedWorkingType, setSelectedWorkingType] = useState<WorkingTypeOption | null>(null);
  const [selectedEducationType, setSelectedEducationType] = useState<EducationTypeOption | null>(null);
  const [selectedExperienceType, setSelectedExperienceType] = useState<ExperienceTypeOption | null>(null);
  const [enabled, setEnabled] = useState(false)
  const [salaryMin, setSalaryMin] = useState<string>("");
  const [salaryMax, setSalaryMax] = useState<string>("");
  const [selectedSalaryType, setSelectedSalaryType] = useState<SalaryDurationType | null>(null);
  const [selectedStatusType, setSelectedStatusType] = useState<StatusType | null>(null);
  const [selectedIntakeType, setSelectedIntakeType] = useState<StatusType | null>(null);
  const [notes, setNotes] = useState("")
  const [selectedCurrency, setSelectedCurrency] = useState<Currency | null>(null);
  const { jobId } = useParams<{ jobId: string }>();
  const [searchQuery, setSearchQuery] = useState("");
  const [isOpen, setIsOpen] = useState(false);
  const [focusedIndex, setFocusedIndex] = useState(0);
  const itemRefs = useRef<HTMLDivElement[]>([]);
  const dispatch = useAppDispatch();

  // job tags
  const [selectedJobTags, setSelectedJobTags] = useState<Tags | null>(null);
  const [searchJobQuery, setSearchJObQuery] = useState("");
  const [isJobOpen, setIsJobOpen] = useState(false);
  const [focusedJobIndex, setFocusedJobIndex] = useState(0);
  const itemRefsJob = useRef<HTMLDivElement[]>([]);
  const [isSaving, setIsSaving] = useState(false);
  const [tags, setTags] = useState<any>(null);
  const { editorInstance } = useEditorContext();
  const [department, setDepartment] = useState<any>(null);
  const { data, fetchStatus, fetchError } = useAppSelector((state: RootState) => state.job);
  const [isSalaryLoading, setIsSalaryLoading] = useState(false);
  const [edit, setEdit] = useState(false)
  const locationFind = useLocation()
  const isAsideOpen = useAppSelector((state: any) => state.layout.isAsideOpen);
  const isApplicationPage = locationFind.pathname.endsWith('/application');
  const { isAddingStep, isReorderSelection } = useJobApplicationContext();
  const { isFormAsideOpen, isFormAsideView, selectedElement } = useAppSelector((state: RootState) => state.questionSteps);
  const [editNotes, setEditNotes] = useState(false);
  const dropdownRef = useRef<HTMLDivElement>(null);
  const [saveNotesLoading, setSaveNotesLoading] = useState(false);
  const [baseDetailsData, setBaseDetailsData] = useState('')
  const [jobBaseData, setJobBaseData] = useState('')
  const navigate = useNavigate()
  // const handleSidebar = () => {
  //   setIsAsideOpen(!isAsideOpen);
  // };

  // Update sidebar state on location change
  useEffect(() => {
    if (locationFind.pathname.endsWith('/detail')) {
      dispatch(setAsideOpen(true));
    } else {
      dispatch(setAsideOpen(false));
    }
  }, [locationFind.pathname, dispatch]);

  const handleSidebar = () => {
    if (locationFind.pathname.endsWith('/detail')) {
      dispatch(toggleAside());
    } else {
      dispatch(setAsideOpen(false));
    }
  };


  const handleMouseOver = () => {
    setIsHovered(true);
  };

  const handleMouseOut = () => {
    setIsHovered(false);
  };

  const toggleCollapse = () => {
    setCollapsed(!collapsed);
  };

  useEffect(() => {
    if (bases && bases.length > 0) {
      const matchedBase = bases.find((base: { id: number }) => base.id.toString() === baseId);
      if (matchedBase) {
        setUserDetails(matchedBase);
      }
    }
    else if (baseId) {
      setUserDetails(baseId);
    }

    else {
      setUserDetails(null);

    }
  }, [baseId, bases]);

  useEffect(() => {
    const fetchData = async () => {
      if (jobId && baseId) {
        try {
          const res = await dispatch(fetchDocument({ baseId, id: jobId })).unwrap();
          setJobBaseData(res.data);
        } catch (error) {
          console.error("Error fetching document:", error);
        }
      }
    };

    fetchData();
  }, [dispatch, jobId, baseId]);


  useEffect(() => {
    if (baseId) {
      const fetchTeams = async () => {
        const storedBaseMember = localStorage.getItem('baseLocationData');
        if (storedBaseMember) {
          setLocation(JSON.parse(storedBaseMember));
        } else {
          try {
            const baseResponse = await dispatch(fetchLocationList(baseId));
            setLocation(baseResponse.payload);
          } catch (error) {
            console.error("Error fetching base member details:", error);
          }
        }
      };
      fetchTeams();
    }
  }, [baseId, dispatch]);



  useEffect(() => {
    if (jobBaseData?.job_location && location?.data?.length > 0) {
      const jobLocationIds = Array.isArray(jobBaseData.job_location)
        ? jobBaseData.job_location // Already an array
        : jobBaseData.job_location.split(','); // Convert string to array

      const matchingLocations = jobLocationIds
        .map((locationId) => {
          const match = location.data.find((loc) => loc.id === locationId);
          return match;
        })
        .filter(Boolean); // Remove null/undefined values

      setSelectedLocations(matchingLocations);
    }
  }, [jobBaseData, location]);



  const handleLocationSelect = async (location) => {
    if (!selectedLocations.some((loc) => loc.id === location.id)) {
      const updatedLocations = [...selectedLocations, location];

      setSelectedLocations(updatedLocations);

      const payload = {
        id: jobId,
        baseId,
        job_location: updatedLocations.map((loc) => loc.id).join(','), // This line converts to comma-separated string
      };

      try {
        await dispatch(updateDocument(payload)).unwrap();
        toast.success('Document updated successfully');
        // dispatch(fetchDocument({ baseId, id: jobId }));
      } catch (error) {
        toast.error(error || 'Failed to update document');
        console.error('Update Document Error:', error);
      }
    }
  };


  const removeLocation = async (locationId) => {
    const updatedLocations = selectedLocations.filter((loc) => loc.id !== locationId);
    setSelectedLocations(updatedLocations);

    const payload = {
      id: jobId,
      baseId,
      job_location: updatedLocations.map((loc) => loc.id).join(','), // Comma-separated IDs
    };

    try {
      await dispatch(updateDocument(payload)).unwrap();
      toast.success('Location removed successfully');
    } catch (error) {
      toast.error('Failed to remove location');
      console.error('Remove Location Error:', error);
    }
  };

  const handleJobTypeChange = async (newValue: JobTypeOption) => {
    setSelectedJobType(newValue);
    const payload = {
      id: jobId,
      baseId,
      job_type: newValue.nlabel
    };

    try {
      await dispatch(updateDocument(payload)).unwrap();
      toast.success('Job updated successfully');
      setJobBaseData(prevData => ({
        ...prevData,
        job_type: newValue.nlabel
      }));
      // dispatch(fetchDocument({ baseId, id: jobId }));
    } catch (error) {
      toast.error(error || 'Failed to update document');
      console.error('Update Document Error:', error);
    }
  };

  const handleWorkingTypeChange = async (newValue: WorkingTypeOption) => {
    setSelectedWorkingType(newValue);
    const payload = {
      id: jobId,
      baseId,
      job_workplace_type: newValue.nlabel
    };

    try {
      await dispatch(updateDocument(payload)).unwrap();
      toast.success('Work updated successfully');
      setJobBaseData(prevData => ({
        ...prevData,
        job_workplace_type: newValue.nlabel
      }));
      // dispatch(fetchDocument({ baseId, id: jobId }));
    } catch (error) {
      toast.error(error || 'Failed to update document');
      console.error('Update Document Error:', error);
    }
  };

  const handleEducationTypeChange = async (newValue: EducationTypeOption) => {
    setSelectedEducationType(newValue);
    const payload = {
      id: jobId,
      baseId,
      educational_requirement: newValue.label
    };

    try {
      await dispatch(updateDocument(payload)).unwrap();
      toast.success('Education updated successfully');
      setJobBaseData(prevData => ({
        ...prevData,
        educational_requirement: newValue.label
      }));
      // dispatch(fetchDocument({ baseId, id: jobId }));
    } catch (error) {
      toast.error(error || 'Failed to update education');
      console.error('Update Document Error:', error);
    }
  };

  const handleExperienceTypeChange = async (newValue: EducationTypeOption) => {
    setSelectedExperienceType(newValue);
    const transformedExperienceLevel =
      newValue.name === 'Entry Level' ? 'Entry_Level' : newValue.name;
    const payload = {
      id: jobId,
      baseId,
      experience_level: transformedExperienceLevel
    };

    try {
      await dispatch(updateDocument(payload)).unwrap();
      toast.success('Experience updated successfully');
      setJobBaseData(prevData => ({
        ...prevData,
        experience_level: transformedExperienceLevel
      }));
      // dispatch(fetchDocument({ baseId, id: jobId }));
    } catch (error) {
      toast.error(error || 'Failed to update experience');
      console.error('Update Document Error:', error);
    }
  };



  const handleSalaryTypeChange = (newValue: SalaryDurationType) => {
    setSelectedSalaryType(newValue);

  };

  const handleStatusTypeChange = async (newValue: StatusType) => {
    setSelectedStatusType(newValue);
    const payload = {
      id: jobId,
      baseId,
      job_status: newValue.name
    };

    try {
      await dispatch(updateDocument(payload)).unwrap();
      toast.success('Status updated successfully');
      setJobBaseData(prevData => ({
        ...prevData,
        job_status: newValue.name
      }));
      // dispatch(fetchDocument({ baseId, id: jobId }));
    } catch (error) {
      toast.error(error || 'Failed to update document');
      console.error('Update Document Error:', error);
    }
  };

  const handleIntakeTypeChange = async (newValue: StatusType) => {
    setSelectedIntakeType(newValue);
    const payload = {
      id: jobId,
      baseId,
      application_intake: newValue.name
    };

    try {
      await dispatch(updateDocument(payload)).unwrap();
      toast.success('Intake updated successfully');
      setJobBaseData(prevData => ({
        ...prevData,
        application_intake: newValue.name
      }));
    } catch (error) {
      toast.error(error || 'Failed to update document');
      console.error('Update Document Error:', error);
    }
  };



  const filteredCurrencies = currencyData.filter(currency =>
    currency.currency.toLowerCase().includes(searchQuery.toLowerCase()) ||
    currency.code.toLowerCase().includes(searchQuery.toLowerCase())
  );

  // useEffect(() => {

  //   if (edit && jobBaseData?.salary_currency) {
  //     setSelectedCurrency(jobBaseData.salary_currency);
  //   }
  // }, [edit, jobBaseData?.salary_currency]);




  const handleCurrencySelect = (selected: Currency) => {
    setSelectedCurrency(selected);
    setIsOpen(false);
    setFocusedIndex(0);
  };

  const handleKeyDown = (e: React.KeyboardEvent) => {
    if (!isOpen) return;

    if (e.key === 'ArrowDown') {
      // Navigate down
      e.preventDefault();
      setFocusedIndex((prevIndex) => {
        const nextIndex = (prevIndex + 1) % filteredCurrencies.length;
        scrollToItem(nextIndex);
        return nextIndex;
      });
    } else if (e.key === 'ArrowUp') {
      // Navigate up
      e.preventDefault();
      setFocusedIndex((prevIndex) => {
        const nextIndex = (prevIndex - 1 + filteredCurrencies.length) % filteredCurrencies.length;
        scrollToItem(nextIndex);
        return nextIndex;
      });
    } else if (e.key === 'Enter') {
      // Select the focused item
      e.preventDefault();
      if (filteredCurrencies[focusedIndex]) {
        handleCurrencySelect(filteredCurrencies[focusedIndex]);
      }
    } else if (e.key === 'Escape') {
      // Close the dropdown
      setIsOpen(false);
    }
  };

  const scrollToItem = (index: number) => {
    const item = itemRefs.current[index];
    if (item) {
      item.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
    }
  };

  useEffect(() => {
    if (isOpen) {
      window.addEventListener('keydown', handleKeyDown as any);
    } else {
      window.removeEventListener('keydown', handleKeyDown as any);
    }
    return () => {
      window.removeEventListener('keydown', handleKeyDown as any);
    };
  }, [isOpen, focusedIndex, filteredCurrencies]);



  // job tags

  useEffect(() => {
    if (baseId) {
      const fetchData = async () => {
        const storedBaseMember = localStorage.getItem('baseTagsData');
        if (storedBaseMember) {
          try {
            const parsedData = JSON.parse(storedBaseMember);
            if (parsedData.data) {
              setTags(parsedData.data);
            } else {
              console.error("Invalid data format in localStorage for baseTagsData");
            }
          } catch (error) {
            console.error("Failed to parse baseTagsData from localStorage:", error);
          }
        }
      };
      fetchData();
    }
  }, [baseId]);





  const filteredCurrenciesJob = Array.isArray(tags)
    ? tags.filter(currency =>
      currency.tag_name.toLowerCase().includes(searchJobQuery.toLowerCase())
    )
    : [];



  const handleJobSelect = async (selected: Tags) => {
    setSelectedJobTags(selected);
    setIsJobOpen(false);
    setFocusedJobIndex(0);
    const payload = {
      id: jobId,
      baseId,
      job_tag: selected.id
    };

    try {
      await dispatch(updateDocument(payload)).unwrap();
      toast.success('Tags updated successfully');
      setJobBaseData(prevData => ({
        ...prevData,
        job_tag: selected.id
      }));
      // dispatch(fetchDocument({ baseId, id: jobId }));
    } catch (error) {
      toast.error(error || 'Failed to update tags');
      console.error('Update Document Error:', error);
    }
  };

  const handleKeyDownJob = (e: React.KeyboardEvent) => {
    if (!isJobOpen) return;

    if (e.key === 'ArrowDown') {
      // Navigate down
      e.preventDefault();
      setFocusedJobIndex((prevIndex) => {
        const nextIndex = (prevIndex + 1) % filteredCurrenciesJob.length;
        scrollToItem1(nextIndex);
        return nextIndex;
      });
    } else if (e.key === 'ArrowUp') {
      // Navigate up
      e.preventDefault();
      setFocusedJobIndex((prevIndex) => {
        const nextIndex = (prevIndex - 1 + filteredCurrenciesJob.length) % filteredCurrenciesJob.length;
        scrollToItem1(nextIndex);
        return nextIndex;
      });
    } else if (e.key === 'Enter') {
      e.preventDefault();
      if (filteredCurrenciesJob[focusedJobIndex]) {
        handleJobSelect(filteredCurrenciesJob[focusedJobIndex]);
      }
    } else if (e.key === 'Escape') {
      // Close the dropdown
      setIsJobOpen(false);
    }
  };

  const scrollToItem1 = (index: number) => {
    const item = itemRefs.current[index];
    if (item) {
      item.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
    }
  };

  useEffect(() => {
    if (isJobOpen) {
      window.addEventListener('keydown', handleKeyDownJob as any);
    } else {
      window.removeEventListener('keydown', handleKeyDownJob as any);
    }
    return () => {
      window.removeEventListener('keydown', handleKeyDownJob as any);
    };
  }, [isJobOpen, focusedJobIndex, filteredCurrenciesJob]);


  useEffect(() => {
    if (edit) {
      setSalaryMin(jobBaseData?.salary_min || ""); // Default to an empty string if no value is available
    }
  }, [edit, jobBaseData?.salary_min]);

  useEffect(() => {
    if (edit) {
      setSalaryMax(jobBaseData?.salary_max || ""); // Default to an empty string if no value is available
    }
  }, [edit, jobBaseData?.salary_max]);

  useEffect(() => {
    if (jobBaseData?.job_note) {
      setNotes(jobBaseData.job_note); // Update state when data changes
    }
  }, [jobBaseData?.job_note]);

  const handleNotesChange = (event: React.ChangeEvent<HTMLTextAreaElement>) => {
    setNotes(event.target.value); // Always update the state
  };

  const handleInputChange = (event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    const { name, value } = event.target;
    if (name === "salary_min") {
      setSalaryMin(value);
    } else if (name === "salary_max") {
      setSalaryMax(value);
    }
  };


  const handleSaveNotes = async () => {
    setSaveNotesLoading(true);

    const payload = {
      id: jobId,
      baseId,
      job_note: notes,
    };

    try {
      await dispatch(updateDocument(payload)).unwrap();
      toast.success("Notes saved successfully");
      setEditNotes(false);

      const res = await dispatch(fetchDocument({ baseId, id: jobId })).unwrap();
      if (res.status === 200) {
        localStorage.setItem('jobPostDetailsData', JSON.stringify(res.data));
      }
    } catch (error) {
      console.error("Failed to save notes:", error);
      toast.error("Failed to save notes");
    } finally {
      setSaveNotesLoading(false);
    }
  };





  const handleSave = async () => {
    setIsSaving(true);
    try {
      if (editorInstance) {
        const htmlContent = editorInstance.getHTML();
        const jsonContent = editorInstance.getJSON();


        const payload = {
          id: jobId,
          baseId: baseId,
          job_description: JSON.stringify(jsonContent)
        };

        const result = await dispatch(updateDocument(payload)).unwrap();
        toast.success('Document saved successfully');
      }
    } catch (error) {
      console.error('Failed to save document:', error);
      toast.error('Failed to save document');
    } finally {
      setIsSaving(false);
    }
  };

  // department 

  useEffect(() => {
    if (baseId) {
      const fetchData = async () => {
        const storedBaseMember = localStorage.getItem('baseDepartmentData');
        if (storedBaseMember) {
          try {
            const parsedData = JSON.parse(storedBaseMember);
            if (parsedData.data) {
              setDepartment(parsedData.data);
            } else {
              console.error("Invalid data format in localStorage for department");
            }
          } catch (error) {
            console.error("Failed to parse baseTagsData from localStorage:", error);
          }
        }
      };
      fetchData();
    }
  }, [baseId]);



  // const findDepartmentName = jobBaseData?.job_department_id
  //   ? department.find((dep) => dep.id === jobBaseData?.job_department_id)?.department_name
  //   : null;
  const findDepartmentName = jobBaseData?.job_department_id && Array.isArray(department)
    ? department.find((dep) => dep.id === jobBaseData.job_department_id)?.department_name
    : null;



  const findTagsName = jobBaseData?.job_tag && Array.isArray(tags)
    ? tags.find((tag) => tag.id === jobBaseData.job_tag)?.tag_name
    : null;


  const handleSalarySave = () => {
    // Construct the payload dynamically based on provided values
    const payload: Record<string, any> = {};
    if (jobId) payload.id = jobId;
    if (baseId) payload.baseId = baseId;
    if (salaryMin) payload.salary_min = salaryMin;
    if (salaryMax) payload.salary_max = salaryMax;
    if (selectedCurrency?.currency) payload.salary_currency = selectedCurrency.code;
    if (selectedSalaryType?.name) payload.salary_duration = selectedSalaryType.name;
    //Salary display
    //enable
    if (enabled) payload.salary_display = enabled

    setIsSalaryLoading(true); // Start loading

    dispatch(updateDocument(payload))
      .unwrap()
      .then(() => {
        toast.success('Salary updated successfully');
      })
      .catch((error) => {
        console.error('Failed to update salary:', error);
        toast.error('Failed to update salary');
      })
      .finally(() => {
        setIsSalaryLoading(false); // Stop loading
      });
  };

  const handleEdit = () => {
    setEdit((prevEdit) => !prevEdit); // Toggle the `edit` state
    setEnabled(false); // Disable the switch when editing
  };

  const handleEnable = () => {
    setEnabled((prevEnabled) => !prevEnabled); // Toggle the `enabled` state
    setEdit(false); // Exit edit mode when enabling the switch
  };

  const handleEditNotes = () => {
    setEditNotes((prevEditNotes) => !prevEditNotes); // Toggle the `editNotes` state
  }

  // Function to handle outside click
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target as Node)) {
        setIsJobOpen(false);
      }
    };

    if (isJobOpen) {
      document.addEventListener("mousedown", handleClickOutside);
    } else {
      document.removeEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isJobOpen]);



  useEffect(() => {
    if (baseId) {
      const fetchData = async () => {
        const storedBaseDetails = localStorage.getItem('baseDetails');
        if (storedBaseDetails) {
          setBaseDetailsData(JSON.parse(storedBaseDetails));

        }
      };
      fetchData();
    }
  }, [baseId, dispatch]);


  const handleNavigateToJob = () => {
    if (jobId) {
      window.open(
        `https://jobs.teamer.app/${baseDetailsData?.data?.base?.base_slug}/${jobId}`,
        "_blank"
      );
    }
  };

  const getTimeAgo = (timestamp) => {
    const now = new Date();
    const updated = new Date(timestamp);
    const diffMs = now - updated;

    const diffSec = Math.floor(diffMs / 1000);
    const diffMin = Math.floor(diffSec / 60);
    const diffHr = Math.floor(diffMin / 60);
    const diffDay = Math.floor(diffHr / 24);

    if (diffSec < 60) return `${diffSec} seconds ago`;
    if (diffMin < 60) return `${diffMin} minutes ago`;
    if (diffHr < 24) return `${diffHr} hours ago`;
    if (diffDay < 7) return `${diffDay} days ago`;

    // fallback to date if it's too old
    return updated.toLocaleDateString('en-GB', {
      day: 'numeric',
      month: 'long',
      year: 'numeric',
    });
  };


  return (
    <div className="h-screen">
      <Sidebar userDetails={userDetails} />
      <div className='lg:pl-[225px]'>
        <div className="sticky top-0" style={{ zIndex: 0 }}>
          <div className="flex h-[56px] shrink-0 items-center gap-x-4 bg-white px-4 shadow-custom-1 sm:gap-x-6 sm:px-6 lg:px-4">
            <button type="button" className="-m-2.5 p-2.5 text-gray-700 lg:hidden">
              <span className="sr-only">Open sidebar</span>

              <svg
                xmlns="http://www.w3.org/2000/svg"
                width={24}
                height={24}
                viewBox="0 0 24 24"
                fill="none"
                stroke="#0000007a"
                strokeWidth={2}
                strokeLinecap="round"
                strokeLinejoin="round"
                className="icon icon-tabler icons-tabler-outline icon-tabler-search  w-[1.2rem] h-[1.2rem] text-[#0000007a]"
              >
                <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                <path d="M10 10m-7 0a7 7 0 1 0 14 0a7 7 0 1 0 -14 0" />
                <path d="M21 21l-6 -6" />
              </svg>

            </button>
            <div className="h-6 w-px bg-gray-900/10 lg:hidden" aria-hidden="true" />
            <div className="flex items-center justify-between w-full">
              <h2 className="text-black-100 font-semibold text-sm capitalize">{jobBaseData?.job_title}</h2>

              <div className="flex items-center gap-2">
                {/* <button
                  onClick={handleSave}
                  className='group inline-flex px-4 shrink-0 select-none items-center transition-colors duration-100 wg-antialiased focus:outline-0 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 disabled:pointer-events-none gap-0 px-8px py-1 rounded-lg text-white outline-primary disabled:opacity-50 bg-indigo-600 hover:bg-indigo-500
                 focus-visible:outline-indigo-600 justify-start [&>span]:flex [&>span]:items-center [&>span]:gap-[6px] text-[13px] font-medium'
                >
                  {isSaving ? (
                    <div className='flex items-center  gap-[6px]'>
                      Save
                      <div className="simple-spinner">
                        <span></span>
                      </div>
                    </div>
                  ) : (
                    'Save'
                  )}
                </button> */}
                <span className="inline-flex items-center leading-4 rounded-md capitalize bg-gray-50 px-3 py-2 text-xs font-medium text-gray-600 ring-1 ring-inset ring-gray-500/10">
                  {jobBaseData?.job_status}
                </span>
                <div className="flex gap-x-4 self-stretch lg:gap-x-6 px-[0.75rem]">
                  {/* <button
                    onClick={handleSidebar}
                    className='rounded-md  duration-200 font-[600] text-[0.8125rem] h-[32px] w-[32px] flex items-center justify-center border border-solid border-[#e7e7e8]'>
                    <svg
                      stroke="currentColor"
                      fill="none"
                      strokeWidth={2}
                      viewBox="0 0 24 24"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      aria-hidden="true"
                      focusable="false"
                      height="1.1em"
                      width="1.1em"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <rect x={3} y={3} width={18} height={18} rx={2} ry={2} />
                      <line x1={9} y1={3} x2={9} y2={21} />
                    </svg>

                  </button> */}

                <button
                    className="rounded-md duration-200 font-[600] text-[0.8125rem] h-[32px] w-[32px] flex items-center justify-center border border-solid border-[#e7e7e8]"
                    style={{
                      transitionProperty:
                        "background-color, border-color, color, fill, stroke, opacity, box-shadow, transform"
                    }}
                    onClick={handleNavigateToJob}
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      fill="none"
                      viewBox="0 0 24 24"
                      strokeWidth="1.5"
                      stroke="currentColor"
                      aria-hidden="true"
                      data-slot="icon"
                      className="w-[1.1em] h-[1.1em] text-[#000]"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        d="m4.5 19.5 15-15m0 0H8.25m11.25 0v11.25"
                      />
                    </svg>
                  </button>

                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <main className=" pl-6 bg-white lg:pl-[225px] h-full w-full">
        <div className='relative flex-1 flex h-full'>
          <div
            className={
              isAddingStep || isReorderSelection || isFormAsideOpen || isFormAsideView
                ? 'overflowing-element hovered mq1023:max-w-full mq1800:max-w-[71.2%] mq3000:max-w-[78.8%] flex-1 w-full px-5 lg:px-[60px] overflow-y-auto view-feedback-data'
                : 'new-feedbackoverflow mq1023:max-w-full mq1800:max-w-[100%] mq3000:max-w-[100%] flex-1 w-full px-5 lg:px-[60px] overflow-y-auto view-feedback-data overflowing-element !overflow-auto'
            } onMouseOver={handleMouseOver}
            onMouseOut={handleMouseOut}
          >
            <div
              className={`max-w-full ${isApplicationPage ? 'md:max-w-[710px] lg:max-w-[710px]' : 'md:max-w-[710px] lg:max-w-[710px]'
                } m-auto`}
            // className='max-w-full md:max-w-[710px] lg:max-w-[710px] m-auto'
            >
              {children}
            </div>
          </div>

          <div
            className={`flex flex-col min-w-[200px] bg-white border-t-0 border border-light-gray-200 border-solid absolute lg:static top-0 right-0 max-w-[80%] view-feedback-right-side`}
            style={{
              width: isAsideOpen ? '350px' : '350px',
              transform: isAsideOpen ? 'none' : 'none',
              marginRight: isAsideOpen ? '0' : '-400px',
              height: isAsideOpen ? 'calc(100vh - 56px)' : '',
              ...(window.innerWidth <= 768 && {
                width: isAsideOpen ? '300px' : '300px',
                marginRight: isAsideOpen ? '0' : '-300px',
              }),
            }}
          >
            <div className='h-full'>
              <aside className='h-auto flex flex-col justify-stretch min-h-[3rem] 
border-b border-l-0 border-r-0 border-solid border-light-gray-200 items-start gap-4'>
                <div className=' flex items-start justify-center w-full'>
                  <div className='mx-auto w-full'>
                    <div className="flex items-center m-[1.2rem] max-w-full w-fit mb-5 font-[500] leading-[1.2] bg-light-gray-100 rounded-full text-[0.75rem] px-[0.5rem] py-[5px] gap-2">
                      <span className="text-[#52555a] capitalize">#{jobBaseData.job_ref_id}</span>
                    </div>
                    <div className="mb-2  px-[1.2rem]">
                      <a
                        href="#"
                        // onClick={toggleCollapse}
                        className="h-8 items-center rounded-lg bg-transparent  text-gray-600 font-medium text-[0.8125rem] 
                          focus:outline-none px-2 justify-start inline-flex"
                      >
                        Details
                        <div className={`${collapsed ? 'rotate-180' : 'rotate-0'} h-6 w-6 flex-shrink-0 font-semibold transform transition-transform duration-300`}>
                          {/* <svg
                      width={24}
                      height={24}
                      fill="none"
                      className="h-6 w-6 fill-transparent stroke-current text-wedges-gray-400"
                    >
                      <path
                        stroke="currentColor"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="1.5"
                        d="M15.25 10.75 12 14.25l-3.25-3.5"
                      />
                    </svg> */}
                        </div>
                      </a>
                      <AnimatePresence initial={false}>
                        {!collapsed && (
                          <motion.div
                            initial={{ height: 0, overflow: 'hidden', backgroundColor: 'white' }}
                            animate={{ height: 'auto', overflow: 'inherit', backgroundColor: 'white' }}
                            exit={{ height: 0, overflow: 'hidden', backgroundColor: 'white' }}
                            transition={{ height: { duration: 0.5 }, overflow: 'hidden', backgroundColor: 'red' }}
                          // className="overflow-hidden"
                          >
                            <div className=" pl-[0px]">
                              <div className='w-full'>
                                {/* location */}
                                <div className="w-full flex items-start justify-between lg:justify-start py-1">
                                  <div className="mr-2 py-1 px-2 font-normal text-dark-black-200 text-[13px] w-[45%]">
                                    Job Location
                                  </div>


                                  <div className="w-[55%] flex flex-col">
                                    {/* Selected Location Labels */}
                                    <div className="flex gap-x-2 flex-wrap items-center ml-1">
                                      {selectedLocations.map((location) => (
                                        <div
                                          key={location.id}
                                          className="flex items-center max-w-full font-[500] bg-light-gray-100 rounded-full leading-[1.2] text-[0.75rem] px-[0.5rem] py-[5px] gap-1 mb-1.5"
                                        >

                                          <span className="text-[#52555a] capitalize">{location.location_city}, {location?.location_country}</span>
                                          <button
                                            onClick={() => removeLocation(location.id)}
                                            className=""
                                          >
                                            <CrossIcon1 />
                                          </button>
                                        </div>
                                      ))}
                                    </div>

                                    {/* Location Selector */}
                                    <Listbox onChange={handleLocationSelect}>
                                      {({ open }) => (
                                        <div className="relative">
                                          <ListboxButton className="w-fit h-[32px] flex items-center justify-between gap-2  cursor-pointer capitalize rounded-md bg-white 
                                    py-1 px-2 text-left text-[12px] text-[#52555a] font-medium bg-transparent border-solid hover:!border-light-gray-200 border border-white">
                                            <span className='block truncate text-[13px] leading-4 whitespace-nowrap max-w-[140px] w-full overflow-hidden text-ellipsis text-start'>
                                              {/* {selectedLocations.length > 0
? selectedLocations.map((loc) => `${loc.location_city}, ${loc.location_country}`).join(', ')
: 'Add location'} */}
                                              Add location
                                            </span>

                                          </ListboxButton>

                                          <Transition
                                            show={open}
                                            enter="transition duration-100 ease-out"
                                            enterFrom="transform scale-95 opacity-0"
                                            enterTo="transform scale-100 opacity-100"
                                            leave="transition duration-75 ease-out"
                                            leaveFrom="transform scale-100 opacity-100"
                                            leaveTo="transform scale-95 opacity-0"
                                          >
                                            <ListboxOptions className="absolute z-10 w-full mt-1 bg-white rounded-md shadow-lg max-h-60 py-1 ring-1 ring-black ring-opacity-5 overflow-auto focus:outline-none text-sm">
                                              {location?.data.map((location) => (
                                                <Listbox.Option
                                                  key={location.id}
                                                  value={location}
                                                  className={({ active }) =>
                                                    `${active ? 'bg-gray-100' : ''} cursor-pointer select-none relative py-2 pl-3 pr-9`
                                                  }
                                                >
                                                  <span className="block truncate font-normal text-[13px]
                                             leading-4 whitespace-nowrap max-w-[140px] w-full 
                                              overflow-hidden text-ellipsis text-start">{location.location_city}, {location?.location_country}</span>
                                                </Listbox.Option>
                                              ))}
                                            </ListboxOptions>
                                          </Transition>
                                        </div>
                                      )}
                                    </Listbox>
                                  </div>


                                </div>
                                {/* job department id */}
                                {
                                  findDepartmentName &&
                                  <div className="w-full flex items-center justify-between lg:justify-start py-1">
                                    <div className="mr-2 py-1 px-2 font-normal text-dark-black-200 text-[13px] w-[45%]">
                                      Department Id
                                    </div>


                                    <div className="w-[55%] flex flex-col ml-2">
                                      <span data-title={findDepartmentName}
                                        className="table-tooltip capitalize before:!bottom-[20px] max-w-[150px] min-w-auto w-max
                                      rounded-md bg-gray-50 px-2 text-xs py-[2px] font-medium text-gray-600 ring-1 ring-inset ring-gray-500/10">
                                        <span className=' line-clamp-1'>
                                          {findDepartmentName}
                                        </span>
                                      </span>
                                    </div>


                                  </div>
                                }


                                {/* working type */}
                                <div className="w-full flex items-center justify-between lg:justify-start py-1">
                                  <div className="mr-2 py-1 px-2 font-normal text-dark-black-200 text-[13px] w-[45%] capitalize">
                                    Workplace type
                                  </div>


                                  <div className="w-[55%] flex flex-col">
                                    <Listbox value={selectedWorkingType} onChange={handleWorkingTypeChange}>
                                      {({ open }) => (
                                        <div className="relative w-[100%]">
                                          <Listbox.Button
                                            className="relative ml-1 justify-center flex items-center cursor-pointer rounded-md bg-white
py-1 px-2 text-left text-[12px] text-[#52555a] font-medium bg-transparent"
                                          >

                                            <div className="flex items-center gap-1">
                                              {jobBaseData?.job_workplace_type ? (
                                                <>
                                                  <span className="truncate text-[13px] leading-4 whitespace-nowrap max-w-[140px] w-full overflow-hidden text-ellipsis text-start">
                                                    {wokringTypeOptions.map((option) =>
                                                      jobBaseData.job_workplace_type === option.nlabel ? (
                                                        <div className='flex items-center justify-start gap-x-1.5'>
                                                          <span
                                                            key={option.id}
                                                            className="flex h-[8px] w-[8px] shrink-0 items-center justify-center rounded-full border-none text-[0.625rem] 
      font-medium text-white capitalize"
                                                            style={{
                                                              backgroundColor: option.icon,
                                                            }}
                                                          >

                                                          </span>
                                                          <span className="truncate text-[13px] leading-4 whitespace-nowrap max-w-[140px] w-full overflow-hidden text-ellipsis text-start">
                                                            {selectedWorkingType?.name || option.name}
                                                          </span>
                                                        </div>
                                                      ) : null
                                                    )}
                                                  </span>
                                                </>
                                              ) : (
                                                <span className="truncate text-[13px] leading-4 whitespace-nowrap max-w-[140px] w-full overflow-hidden text-ellipsis text-start">
                                                  Select Work
                                                </span>
                                              )}

                                            </div>


                                          </Listbox.Button>

                                          <Transition show={open} leave="transition ease-in duration-100" leaveFrom="opacity-100" leaveTo="opacity-0">
                                            <Listbox.Options className="absolute z-10 w-[120px] left-[0px] mt-1 max-h-60 
        overflow-auto rounded-md bg-white py-1 text-base shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none sm:text-sm">
                                              {wokringTypeOptions.map((option) => (
                                                <Listbox.Option
                                                  key={option.id}
                                                  className={({ active }) =>
                                                    `relative cursor-default select-none py-1.5 pl-3 pr-9 text-[13px] ${active ? 'bg-light-gray-100 text-dark-black-100' : 'text-dark-black-100'
                                                    }`
                                                  }
                                                  value={option}
                                                >
                                                  {({ selected }) => (
                                                    <div className="flex items-center gap-2">
                                                      <span
                                                        style={{ backgroundColor: option.icon }}
                                                        className="flex h-[8px] w-[8px] shrink-0 items-center justify-center
                  rounded-full border-none text-[0.625rem] font-medium text-white capitalize"
                                                      />
                                                      <span
                                                        className={`block truncate font-medium text-[13px] leading-4 whitespace-nowrap max-w-[140px] w-full 
                  overflow-hidden text-ellipsis text-start capitalize ${selected ? 'font-semibold' : 'font-normal'}`}
                                                      >
                                                        {option.name}
                                                      </span>
                                                    </div>
                                                  )}
                                                </Listbox.Option>
                                              ))}
                                            </Listbox.Options>
                                          </Transition>
                                        </div>
                                      )}
                                    </Listbox>
                                  </div>


                                </div>
                                {/* job type */}
                                <div className="w-full flex items-center justify-between lg:justify-start py-1">
                                  <div className="mr-2 py-1 px-2 font-normal text-dark-black-200 text-[13px] w-[45%] capitalize">
                                    Job type
                                  </div>
                                  <div className="w-[55%] flex flex-col">
                                    <Listbox value={selectedJobType} onChange={handleJobTypeChange}>
                                      {({ open }) => (

                                        <div className="relative w-[100%]">
                                          <Listbox.Button className="relative ml-1 flex items-center justify-start cursor-pointer rounded-md bg-transparent border border-white 
      py-1 px-2 text-left text-[12px] text-[#52555a] font-medium hover:!border-light-gray-200 capitalize">
                                            <div className="flex items-center gap-1">

                                              {jobBaseData?.job_type ? (
                                                <>
                                                  <span className="truncate text-[13px] leading-4 whitespace-nowrap max-w-[140px] w-full overflow-hidden text-ellipsis text-start">
                                                    {jobTypeOptions.map((option) =>
                                                      jobBaseData.job_type === option.nlabel ? (
                                                        <div className='flex items-center justify-start gap-x-1.5'>
                                                          <span
                                                            key={option.id}
                                                            className="flex h-[8px] w-[8px] shrink-0 items-center justify-center rounded-full border-none text-[0.625rem] 
                                                    font-medium text-white capitalize"
                                                            style={{
                                                              backgroundColor: option.label,
                                                            }}
                                                          >

                                                          </span>
                                                          <span className="truncate text-[13px] leading-4 whitespace-nowrap max-w-[140px] w-full overflow-hidden text-ellipsis text-start">
                                                            {selectedJobType?.name || option.name}
                                                          </span>
                                                        </div>
                                                      ) : null
                                                    )}
                                                  </span>
                                                </>
                                              ) : (
                                                <span className="truncate text-[13px] leading-4 whitespace-nowrap max-w-[140px] w-full overflow-hidden text-ellipsis text-start">
                                                  Select Job
                                                </span>
                                              )}

                                            </div>
                                          </Listbox.Button>

                                          <Transition show={open} leave="transition ease-in duration-100" leaveFrom="opacity-100" leaveTo="opacity-0">
                                            <Listbox.Options className="absolute z-10 w-[140px] left-[0px] mt-1 max-h-60 
        overflow-auto rounded-md bg-white py-1 text-base shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none sm:text-sm">
                                              {jobTypeOptions.map((option) => (
                                                <Listbox.Option
                                                  key={option.id}
                                                  className={({ active }) =>
                                                    `relative cursor-default select-none py-1.5 pl-3 pr-9 text-[13px] ${active ? 'bg-light-gray-100 text-dark-black-100' : 'text-dark-black-100'
                                                    }`
                                                  }
                                                  value={option}
                                                >
                                                  {({ selected }) => (
                                                    <div className="flex items-center gap-2">
                                                      <span
                                                        style={{ backgroundColor: option.label }}
                                                        className="flex h-[8px] w-[8px] shrink-0 items-center justify-center
                  rounded-full border-none text-[0.625rem] font-medium text-white capitalize"
                                                      />
                                                      <span
                                                        className={`block truncate font-medium text-[13px] leading-4 whitespace-nowrap max-w-[140px] w-full 
                  overflow-hidden text-ellipsis text-start capitalize ${selected ? 'font-semibold' : 'font-normal'}`}
                                                      >
                                                        {option.name}
                                                      </span>
                                                    </div>
                                                  )}
                                                </Listbox.Option>
                                              ))}
                                            </Listbox.Options>
                                          </Transition>
                                        </div>
                                      )}
                                    </Listbox>
                                  </div>
                                </div>

                                {/* job tags */}
                                <div className="w-full flex items-center justify-between lg:justify-start py-1">
                                  <div className="mr-2 py-1 px-2 font-normal text-dark-black-200 text-[13px] w-[45%] capitalize">
                                    Job tags
                                  </div>
                                  <div className="w-[55%] flex flex-col">
                                    <div className="relative" ref={dropdownRef}>
                                      <button
                                        type="button"
                                        className="w-fit h-[32px] ml-1 flex items-center justify-between gap-2 cursor-pointer capitalize rounded-md bg-white py-1 px-2
      text-left text-[12px] text-[#52555a] font-medium bg-transparent border-solid hover:!border-light-gray-200 border border-white"
                                        onClick={() => setIsJobOpen(!isJobOpen)}
                                      >
                                        <span className="mr-2 text-[13px] text-[#374151] line-clamp-1">
                                          {
                                            findTagsName ? findTagsName : selectedJobTags?.tag_name ? selectedJobTags.tag_name : 'Select Job'
                                          }
                                        </span>
                                      </button>

                                      {isJobOpen && (
                                        <div className="absolute z-10 mt-1 left-[-20px] w-full rounded-md shadow-lg bg-white ring-1 ring-black ring-opacity-5 focus:outline-none">
                                          <div className="py-1" role="menu" aria-orientation="vertical" aria-labelledby="options-menu">
                                            <div className="px-4 py-2">
                                              <input
                                                type="text"
                                                className="w-full bg-transparent border-none focus:ring-0 focus:outline-none p-0 text-[14px] text-[#374151]"
                                                placeholder="Search tags..."
                                                value={searchJobQuery}
                                                onChange={(e) => setSearchJObQuery(e.target.value)}
                                              />
                                            </div>
                                            <div className="max-h-[150px] overflow-y-auto overflow-x-hidden">
                                              {filteredCurrenciesJob.length > 0 ? (
                                                filteredCurrenciesJob.map((currency, index) => (
                                                  <div
                                                    key={index}
                                                    className={`flex items-center px-4 py-2 cursor-pointer hover:bg-gray-100 ${index === focusedJobIndex ? 'bg-gray-200' : ''
                                                      }`}
                                                    onClick={() => handleJobSelect(currency)}
                                                    ref={(el) => (itemRefsJob.current[index] = el!)} // Assign ref to each item
                                                  >
                                                    <div className="flex items-center gap-y-[2px]">
                                                      <span className="text-[12px] text-[#374151] font-semibold leading-4 truncate capitalize">
                                                        {currency.tag_name}
                                                      </span>

                                                    </div>
                                                  </div>
                                                ))
                                              ) : (
                                                <div className="px-4 py-2 text-gray-500 text-sm">No Tags found</div>
                                              )}
                                            </div>
                                          </div>
                                        </div>
                                      )}
                                    </div>

                                  </div>
                                </div>



                                {/* education requirment */}
                                <div className="w-full flex items-center justify-between lg:justify-start py-1">
                                  <div className="mr-2 py-1 px-2 font-normal text-dark-black-200 text-[13px] w-[45%] capitalize">
                                    Education type
                                  </div>
                                  <div className="w-[55%] flex flex-col">
                                    <Listbox value={selectedEducationType} onChange={handleEducationTypeChange}>
                                      {({ open }) => (
                                        <div className="relative w-[100%]">
                                          <Listbox.Button
                                            className="w-fit h-[32px] ml-1 flex items-center justify-between gap-2 cursor-pointer capitalize rounded-md bg-white py-1 px-2 text-left text-[12px] text-[#52555a] font-medium bg-transparent border-solid hover:!border-light-gray-200 border border-white"
                                          >

                                            {jobBaseData?.educational_requirement ? (
                                              <>
                                                <span className="truncate text-[13px] leading-4 whitespace-nowrap max-w-[140px] w-full overflow-hidden text-ellipsis text-start">
                                                  {educationTypeOptions.map((option) =>
                                                    jobBaseData.educational_requirement === option.label ? (
                                                      <div className='flex items-center justify-start gap-x-1.5'>
                                                        <span className="truncate text-[13px] leading-4 whitespace-nowrap max-w-[140px] w-full overflow-hidden text-ellipsis text-start">
                                                          {selectedEducationType?.name || option.name}
                                                        </span>
                                                      </div>
                                                    ) : null
                                                  )}
                                                </span>
                                              </>
                                            ) : (
                                              <span className="truncate text-[13px] leading-4 whitespace-nowrap max-w-[140px] w-full overflow-hidden text-ellipsis text-start">
                                                Select education
                                              </span>
                                            )}

                                          </Listbox.Button>

                                          <Transition show={open} leave="transition ease-in duration-100" leaveFrom="opacity-100" leaveTo="opacity-0">
                                            <Listbox.Options className="absolute z-10 w-[180px] left-[-10px] mt-1 max-h-60 
        overflow-auto rounded-md bg-white py-1 text-base shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none sm:text-sm">
                                              {educationTypeOptions.map((option) => (
                                                <Listbox.Option
                                                  key={option.id}
                                                  className={({ active }) =>
                                                    `relative cursor-default select-none py-1.5 pl-3 pr-9 text-[13px] ${active ? 'bg-light-gray-100 text-dark-black-100' : 'text-dark-black-100'
                                                    }`
                                                  }
                                                  value={option}
                                                >
                                                  {({ selected }) => (
                                                    <div className="flex items-center gap-2">

                                                      <span
                                                        className={`block truncate font-medium text-[13px] leading-4 whitespace-nowrap max-w-[140px] w-full 
                  overflow-hidden text-ellipsis text-start capitalize ${selected ? 'font-semibold' : 'font-normal'}`}
                                                      >
                                                        {option.name}
                                                      </span>
                                                    </div>
                                                  )}
                                                </Listbox.Option>
                                              ))}
                                            </Listbox.Options>
                                          </Transition>
                                        </div>
                                      )}
                                    </Listbox>
                                  </div>
                                </div>

                                {/* Experience level */}
                                <div className="w-full flex items-center justify-between lg:justify-start py-1">
                                  <div className="mr-2 py-1 px-2 font-normal text-dark-black-200 text-[13px] w-[45%] capitalize">
                                    experience level
                                  </div>
                                  <div className="w-[55%] flex flex-col">
                                    <Listbox value={selectedExperienceType} onChange={handleExperienceTypeChange}>
                                      {({ open }) => (
                                        <div className="relative w-[100%]">
                                          <Listbox.Button
                                            className="w-fit h-[32px] ml-1 flex items-center justify-between gap-2 cursor-pointer capitalize rounded-md bg-white py-1 px-2 text-left text-[12px] text-[#52555a] font-medium bg-transparent border-solid hover:!border-light-gray-200 border border-white"
                                          >

                                            <div className="flex items-center gap-1 h-[32px]">

                                              {jobBaseData?.experience_level ? (
                                                <>


                                                  <span className="truncate text-[13px] leading-4 whitespace-nowrap max-w-[170px] w-full overflow-hidden text-ellipsis text-start">
                                                    {
                                                      jobBaseData.experience_level === 'Entry_Level' ? 'Entry Level' :
                                                        selectedExperienceType?.name || jobBaseData.experience_level
                                                    }
                                                  </span>
                                                </>
                                              ) : (
                                                <span className="truncate text-[13px] leading-4 whitespace-nowrap max-w-[140px] w-full overflow-hidden text-ellipsis text-start">
                                                  Select Job
                                                </span>
                                              )}
                                            </div>
                                          </Listbox.Button>

                                          <Transition show={open} leave="transition ease-in duration-100" leaveFrom="opacity-100" leaveTo="opacity-0">
                                            <Listbox.Options className="absolute z-10 w-[200px] left-[-26px] mt-1 max-h-60 
        overflow-auto rounded-md bg-white py-1 text-base shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none sm:text-sm">
                                              {experienceTypeOptions.map((option) => (
                                                <Listbox.Option
                                                  key={option.id}
                                                  className={({ active }) =>
                                                    `relative cursor-default select-none py-1.5 pl-3 pr-9 text-[13px] ${active ? 'bg-light-gray-100 text-dark-black-100' : 'text-dark-black-100'
                                                    }`
                                                  }
                                                  value={option}
                                                >
                                                  {({ selected }) => (
                                                    <div className="flex items-center gap-2">

                                                      <span
                                                        className={`block truncate font-medium text-[13px] leading-4 whitespace-nowrap max-w-[170px] w-full 
                  overflow-hidden text-ellipsis text-start capitalize ${selected ? 'font-semibold' : 'font-normal'}`}
                                                      >
                                                        {option.name}
                                                      </span>
                                                    </div>
                                                  )}
                                                </Listbox.Option>
                                              ))}
                                            </Listbox.Options>
                                          </Transition>
                                        </div>
                                      )}
                                    </Listbox>
                                  </div>
                                </div>

                                {/* status type  */}
                                <div className="w-full flex items-center justify-between lg:justify-start py-1">
                                  <div className="mr-2 py-1 px-2 font-normal text-dark-black-200 text-[13px] w-[45%] capitalize">
                                    Status
                                  </div>


                                  <div className="w-[55%] flex flex-col">
                                    <Listbox value={selectedStatusType} onChange={handleStatusTypeChange}>
                                      {({ open }) => (
                                        <div className="relative w-[100%]">
                                          <Listbox.Button
                                            className="w-fit h-[32px] ml-1 flex items-center justify-between gap-2 cursor-pointer capitalize rounded-md bg-white py-1 px-2 text-left text-[12px] text-[#52555a] font-medium bg-transparent border-solid hover:!border-light-gray-200 border border-white"
                                          >
                                            <div className="flex items-center gap-1 h-[32px]">
                                              {jobBaseData?.job_type ? (
                                                <>
                                                  <span className="truncate text-[13px] leading-4 whitespace-nowrap max-w-[140px] w-full overflow-hidden text-ellipsis text-start">
                                                    {StatusTypeOptions.map((option) =>
                                                      jobBaseData.job_status === option.name ? (
                                                        <div className='flex items-center gap-x-1.5'>
                                                          <span
                                                            key={option.id}
                                                            className="flex h-[8px] w-[8px] shrink-0 items-center justify-center rounded-full border-none text-[0.625rem] 
                                                    font-medium text-white capitalize"
                                                            style={{
                                                              backgroundColor: option.icon,
                                                            }}
                                                          >

                                                          </span>
                                                          <span className=" capitalize truncate text-[13px] leading-4 whitespace-nowrap max-w-[140px] w-full overflow-hidden text-ellipsis text-start">
                                                            {selectedStatusType?.name || option.name}
                                                          </span>
                                                        </div>
                                                      ) : null
                                                    )}
                                                  </span>
                                                </>
                                              ) : (
                                                <span className="truncate text-[13px] leading-4 whitespace-nowrap max-w-[140px] w-full overflow-hidden text-ellipsis text-start">

                                                  {selectedStatusType?.name || jobBaseData?.job_status}
                                                </span>
                                              )}

                                            </div>
                                          </Listbox.Button>

                                          <Transition show={open} leave="transition ease-in duration-100" leaveFrom="opacity-100" leaveTo="opacity-0">
                                            <Listbox.Options className="absolute z-10 w-[120px] left-[-50px] mt-1 max-h-60 
        overflow-auto rounded-md bg-white py-1 text-base shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none sm:text-sm">
                                              {StatusTypeOptions.map((option) => (
                                                <Listbox.Option
                                                  key={option.id}
                                                  className={({ active }) =>
                                                    `relative cursor-default select-none py-1.5 pl-3 pr-9 text-[13px] ${active ? 'bg-light-gray-100 text-dark-black-100' : 'text-dark-black-100'
                                                    }`
                                                  }
                                                  value={option}
                                                >
                                                  {({ selected }) => (
                                                    <div className="flex items-center gap-2">
                                                      <span
                                                        style={{ backgroundColor: option.icon }}
                                                        className="flex h-[8px] w-[8px] shrink-0 items-center justify-center
                  rounded-full border-none text-[0.625rem] font-medium text-white capitalize"
                                                      />
                                                      <span
                                                        className={`block truncate font-medium text-[13px] leading-4 whitespace-nowrap max-w-[140px] w-full 
                  overflow-hidden text-ellipsis text-start capitalize ${selected ? 'font-semibold' : 'font-normal'}`}
                                                      >
                                                        {option.name}
                                                      </span>
                                                    </div>
                                                  )}
                                                </Listbox.Option>
                                              ))}
                                            </Listbox.Options>
                                          </Transition>
                                        </div>
                                      )}
                                    </Listbox>
                                  </div>


                                </div>

                                {/* application intake  */}
                                <div className="w-full flex items-center justify-between lg:justify-start py-1">
                                  <div className="mr-2 py-1 px-2 font-normal text-dark-black-200 text-[13px] w-[45%] capitalize">
                                    Application Intake
                                  </div>


                                  <div className="w-[55%] flex flex-col">
                                    <Listbox value={selectedIntakeType} onChange={handleIntakeTypeChange}>
                                      {({ open }) => (
                                        <div className="relative w-[100%]">
                                          <Listbox.Button
                                            className="w-fit h-[32px] ml-1 flex items-center justify-between gap-2 cursor-pointer capitalize rounded-md bg-white py-1 px-2 text-left text-[12px] text-[#52555a] font-medium bg-transparent border-solid hover:!border-light-gray-200 border border-white"
                                          >
                                            <div className="flex items-center gap-1 h-[32px]">
                                              {jobBaseData?.application_intake ? (
                                                <>
                                                  <span className="truncate text-[13px] leading-4 whitespace-nowrap max-w-[140px] w-full overflow-hidden text-ellipsis text-start">
                                                    {IntakeTypeOptions.map((option) =>
                                                      jobBaseData.application_intake === option.name ? (
                                                        <div className='flex items-center gap-x-1.5'>
                                                          <span className=" capitalize truncate text-[13px] leading-4 whitespace-nowrap max-w-[140px] w-full overflow-hidden text-ellipsis text-start">
                                                            {selectedIntakeType?.name || option.name}
                                                          </span>
                                                        </div>
                                                      ) : null
                                                    )}
                                                  </span>
                                                </>
                                              ) : (
                                                <span className="truncate text-[13px] leading-4 whitespace-nowrap max-w-[140px] w-full overflow-hidden text-ellipsis text-start">
                                                  Select Intake
                                                </span>
                                              )}

                                            </div>
                                          </Listbox.Button>

                                          <Transition show={open} leave="transition ease-in duration-100" leaveFrom="opacity-100" leaveTo="opacity-0">
                                            <Listbox.Options className="absolute z-10 w-[120px] left-[-50px] mt-1 max-h-60 
        overflow-auto rounded-md bg-white py-1 text-base shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none sm:text-sm">
                                              {IntakeTypeOptions.map((option) => (
                                                <Listbox.Option
                                                  key={option.id}
                                                  className={({ active }) =>
                                                    `relative cursor-default select-none py-1.5 pl-3 pr-9 text-[13px] ${active ? 'bg-light-gray-100 text-dark-black-100' : 'text-dark-black-100'
                                                    }`
                                                  }
                                                  value={option}
                                                >
                                                  {({ selected }) => (
                                                    <div className="flex items-center gap-2">
                                                      <span
                                                        className={`block truncate font-medium text-[13px] leading-4 whitespace-nowrap max-w-[140px] w-full 
                  overflow-hidden text-ellipsis text-start capitalize ${selected ? 'font-semibold' : 'font-normal'}`}
                                                      >
                                                        {option.name}
                                                      </span>
                                                    </div>
                                                  )}
                                                </Listbox.Option>
                                              ))}
                                            </Listbox.Options>
                                          </Transition>
                                        </div>
                                      )}
                                    </Listbox>
                                  </div>


                                </div>

                              </div>
                            </div>
                          </motion.div>
                        )}
                      </AnimatePresence>
                    </div>
                    <div className='w-full h-[1px] bg-[#00000014] my-4'></div>
                    <div className="mb-2  px-[1.2rem]">
                      <div className='flex items-start justify-between'>
                        <a
                          href="#"
                          // onClick={toggleCollapse}
                          className="h-8 items-center rounded-lg bg-transparent  text-gray-600 font-medium text-[0.8125rem] 
                          focus:outline-none px-2 justify-start inline-flex"
                        >

                          Salary

                          <div className={`${collapsed ? 'rotate-180' : 'rotate-0'} h-6 w-6  font-semibold flex-shrink-0 transform transition-transform duration-300`}>
                            {/* <svg
                      width={24}
                      height={24}
                      fill="none"
                      className="h-6 w-6 fill-transparent stroke-current text-wedges-gray-400"
                    >
                      <path
                        stroke="currentColor"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="1.5"
                        d="M15.25 10.75 12 14.25l-3.25-3.5"
                      />
                    </svg> */}
                          </div>
                        </a>
                        <button className=' text-[13px] text-[#266df0]' onClick={handleEdit}>
                          Edit
                        </button>
                      </div>

                      <AnimatePresence initial={false}>
                        {!collapsed && (
                          <motion.div
                            initial={{ height: 0, overflow: 'hidden', backgroundColor: 'white' }}
                            animate={{ height: 'auto', overflow: 'inherit', backgroundColor: 'white' }}
                            exit={{ height: 0, overflow: 'hidden', backgroundColor: 'white' }}
                            transition={{ height: { duration: 0.5 }, overflow: 'hidden', backgroundColor: 'red' }}
                          // className="overflow-hidden"
                          >
                            <div className=" pl-[0px]">
                              <div className='w-full'>



                                {/* salary */}
                                <div className=" py-1">
                                  <div className='w-full flex items-center justify-between lg:justify-start mt-2'>
                                    <div className="mr-2 py-1 px-2 font-normal text-dark-black-200 text-[13px] w-[40%]">
                                      Salary display
                                    </div>


                                    <div className="w-[60%] flex flex-col justify-end items-end">


                                      <Switch
                                        checked={enabled}
                                        onChange={handleEnable}
                                        className="group relative inline-flex h-5 w-10 shrink-0 cursor-pointer items-center justify-center rounded-full focus:outline-none focus:ring-2 focus:ring-indigo-600 focus:ring-offset-2"
                                      >
                                        <span className="sr-only">Use setting</span>
                                        <span aria-hidden="true" className="pointer-events-none absolute size-full rounded-md bg-white" />
                                        <span
                                          aria-hidden="true"
                                          className="pointer-events-none absolute mx-auto h-4 w-9 rounded-full bg-gray-200 transition-colors duration-200 ease-in-out group-data-[checked]:bg-indigo-600"
                                        />
                                        <span
                                          aria-hidden="true"
                                          className="pointer-events-none absolute left-0 inline-block size-5 transform rounded-full border border-gray-200 bg-white shadow ring-0 transition-transform duration-200 ease-in-out group-data-[checked]:translate-x-5"
                                        />
                                      </Switch>



                                    </div>
                                  </div>

                                  {
                                    edit &&
                                    <>
                                      <div className='w-full mt-8 flex flex-col gap-y-8'>
                                        <div className="relative">
                                          <label
                                            htmlFor="salary_min"
                                            className="absolute -top-2 left-2 inline-block bg-white px-1 text-xs font-normal text-dark-black-200 text-[13px]"
                                          >
                                            Minimum salary
                                          </label>
                                          <input
                                            id="salary_min"
                                            name="salary_min"
                                            type="number"
                                            maxLength={30}
                                            value={salaryMin}
                                            onChange={handleInputChange}
                                            className="block w-full rounded-md border-0 py-1.5 text-[#52555a] text-[13px] shadow-sm ring-1 
              ring-inset ring-gray-300 placeholder:text-[#52555a] font-medium focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:leading-6"
                                          />
                                        </div>

                                      </div>
                                      <div className='w-full mt-8 flex flex-col gap-y-8'>
                                        <div className="relative">
                                          <label
                                            htmlFor="salary_max"
                                            className="absolute -top-2 left-2 inline-block bg-white px-1 text-xs font-normal text-dark-black-200 text-[13px]"
                                          >
                                            Maximum salary
                                          </label>
                                          <input
                                            id="salary_max"
                                            name="salary_max"
                                            type="number"
                                            maxLength={30}
                                            value={salaryMax}
                                            onChange={handleInputChange}
                                            className="block w-full rounded-md border-0 py-1.5 text-[#52555a] text-[13px] shadow-sm ring-1 
              ring-inset ring-gray-300 placeholder:text-[#3b3e42] font-medium focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:leading-6"
                                          />
                                        </div>
                                      </div>

                                      <div className="w-full flex items-center justify-between lg:justify-start py-1 mt-4">
                                        <div className="mr-2 py-1 px-2 font-normal text-dark-black-200 text-[13px] w-[40%] capitalize">
                                          Salary duration
                                        </div>


                                        <div className="w-[60%] flex flex-col  justify-end">
                                          <Listbox value={selectedSalaryType} onChange={handleSalaryTypeChange}>
                                            {({ open }) => (
                                              <div className="relative w-[100%]">
                                                <Listbox.Button
                                                  className="w-fit h-[32px] ml-1 flex items-center justify-between gap-2  cursor-pointer capitalize rounded-md bg-white  py-1 px-2 text-left text-[12px] text-[#52555a] font-medium bg-transparent border-solid hover:!border-light-gray-200 border border-white"
                                                >
                                                  <div className="flex items-center gap-1 h-[32px]">
                                                    {selectedSalaryType ? (
                                                      <span
                                                        className='truncate text-[13px] leading-4 whitespace-nowrap max-w-[140px] w-full overflow-hidden text-ellipsis text-start'
                                                      >
                                                        {selectedSalaryType.name}
                                                      </span>
                                                    ) : (
                                                      <span className="relative  cursor-pointer rounded-md bg-transparent  flex shrink-0 items-center justify-center  text-[13px] font-medium capitalize mr-[-4px]">
                                                        {jobBaseData?.salary_duration || 'Select Salary'}
                                                      </span>
                                                    )}

                                                  </div>
                                                </Listbox.Button>

                                                <Transition show={open} leave="transition ease-in duration-100" leaveFrom="opacity-100" leaveTo="opacity-0">
                                                  <Listbox.Options className="absolute z-10 w-[150px] left-[0px] mt-1 max-h-60 
        overflow-auto rounded-md bg-white py-1 text-base shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none sm:text-sm">
                                                    {SalaryTypeOptions.map((option) => (
                                                      <Listbox.Option
                                                        key={option.id}
                                                        className={({ active }) =>
                                                          `relative cursor-default select-none py-1.5 pl-3 pr-9 text-[13px] ${active ? 'bg-light-gray-100 text-dark-black-100' : 'text-dark-black-100'
                                                          }`
                                                        }
                                                        value={option}
                                                      >
                                                        {({ selected }) => (
                                                          <div className="flex items-center gap-2">

                                                            <span
                                                              className={`block truncate font-medium text-[13px] leading-4 whitespace-nowrap max-w-[140px] w-full 
                  overflow-hidden text-ellipsis text-start capitalize ${selected ? 'font-semibold' : 'font-normal'}`}
                                                            >
                                                              {option.name}
                                                            </span>
                                                          </div>
                                                        )}
                                                      </Listbox.Option>
                                                    ))}
                                                  </Listbox.Options>
                                                </Transition>
                                              </div>
                                            )}
                                          </Listbox>
                                        </div>


                                      </div>
                                      <div className="w-full flex items-center justify-between lg:justify-start py-1">
                                        <div className="mr-2 py-1 px-2 font-normal text-dark-black-200 text-[13px] w-[40%] capitalize">
                                          Currency
                                        </div>
                                        <div className="w-[60%] flex flex-col">
                                          <div className="relative">
                                            <button
                                              type="button"
                                              className="w-fit h-[32px] ml-1 flex items-center justify-between gap-2 cursor-pointer capitalize rounded-md bg-white py-1 px-2
  text-left text-[12px] text-[#52555a] font-medium bg-transparent border-solid hover:!border-light-gray-200 border border-white"
                                              onClick={() => setIsOpen(!isOpen)}
                                            >
                                              <span className="mr-2 text-[13px] text-[#374151]">
                                                {/* Display the selected currency */}
                                                {selectedCurrency
                                                  ? `${selectedCurrency.currency} (${selectedCurrency.code})`
                                                  : 'Select currency'}
                                              </span>
                                            </button>

                                            {isOpen && (
                                              <div className="absolute z-10 mt-2 w-full rounded-md shadow-lg bg-white ring-1 ring-black ring-opacity-5 focus:outline-none">
                                                <div className="py-1" role="menu" aria-orientation="vertical" aria-labelledby="options-menu">
                                                  <div className="px-4 py-2">
                                                    <input
                                                      type="text"
                                                      className="w-full bg-transparent border-none focus:ring-0 focus:outline-none p-0 text-[14px] text-[#374151]"
                                                      placeholder="Search currency..."
                                                      value={searchQuery}
                                                      onChange={(e) => setSearchQuery(e.target.value)}
                                                    />
                                                  </div>
                                                  <div className="max-h-[150px] overflow-y-auto overflow-x-hidden">
                                                    {filteredCurrencies.length > 0 ? (
                                                      filteredCurrencies.map((currency, index) => (
                                                        <div
                                                          key={index}
                                                          className={`flex items-center px-4 py-2 cursor-pointer hover:bg-gray-100 ${index === focusedIndex ? 'bg-gray-200' : ''}`}
                                                          onClick={() => handleCurrencySelect(currency)}
                                                          ref={(el) => (itemRefs.current[index] = el!)} // Assign ref to each item
                                                        >
                                                          <div className="flex items-center gap-y-[2px]">
                                                            <span className="text-[12px] text-[#374151] font-semibold leading-4 truncate">
                                                              {currency.currency}
                                                            </span>
                                                            <span className="text-[12px] text-[#374151] leading-4 truncate ml-1">{currency.code}</span>
                                                          </div>
                                                        </div>
                                                      ))
                                                    ) : (
                                                      <div className="px-4 py-2 text-gray-500 text-sm">No currencies found</div>
                                                    )}
                                                  </div>
                                                </div>
                                              </div>
                                            )}
                                          </div>
                                        </div>

                                      </div>

                                    </>
                                  }


                                  {jobBaseData?.salary_min === null &&
                                    enabled &&
                                    <div className='w-full mt-8 flex flex-col gap-y-8'>
                                      <div className="relative">
                                        <label
                                          htmlFor="salary_min"
                                          className="absolute -top-2 left-2 inline-block bg-white px-1 text-xs font-normal text-dark-black-200 text-[13px]"
                                        >
                                          Minimum salary
                                        </label>
                                        <input
                                          id="salary_min"
                                          name="salary_min"
                                          type="number"
                                          maxLength={30}
                                          value={salaryMin}
                                          onChange={handleInputChange}
                                          className="block w-full rounded-md border-0 py-1.5 text-[#52555a] text-[13px] shadow-sm ring-1 
              ring-inset ring-gray-300 placeholder:text-[#52555a] font-medium focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:leading-6"
                                        />
                                      </div>

                                    </div>
                                  }

                                  {enabled &&
                                    jobBaseData?.salary_min &&
                                    <div className='flex flex-col gap-y-2 px-2 mt-4'>
                                      <div className='flex flex-row items-center justify-between flex-grow shrink-0'>
                                        <div className='flex items-center gap-x-[16px] w-[40%]'>
                                          <span className='flex-shrink whitespace-nowrap overflow-hidden text-ellipsis  font-normal text-dark-black-200 text-[13px]  capitalize'>Min Salary</span>
                                        </div>
                                        <div className='mr-[0px] flex  flex-row items-center flex-grow-0  w-[60%] '>
                                          <div className='ml-3'>
                                            <span className="inline-flex items-center rounded-md bg-gray-50 px-2 py-1 text-xs font-medium text-gray-600 ring-1 ring-inset ring-gray-500/10">
                                              {jobBaseData?.salary_min}
                                            </span>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  }


                                  {jobBaseData?.salary_max === null &&
                                    enabled &&
                                    <div className='w-full mt-8 flex flex-col gap-y-8'>
                                      <div className="relative">
                                        <label
                                          htmlFor="salary_max"
                                          className="absolute -top-2 left-2 inline-block bg-white px-1 text-xs font-normal text-dark-black-200 text-[13px]"
                                        >
                                          Maximum salary
                                        </label>
                                        <input
                                          id="salary_max"
                                          name="salary_max"
                                          type="number"
                                          maxLength={30}
                                          value={salaryMax}
                                          onChange={handleInputChange}
                                          className="block w-full rounded-md border-0 py-1.5 text-[#52555a] text-[13px] shadow-sm ring-1 
              ring-inset ring-gray-300 placeholder:text-[#3b3e42] font-medium focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:leading-6"
                                        />
                                      </div>
                                    </div>
                                  }

                                  {enabled &&
                                    jobBaseData?.salary_max &&
                                    <div className='flex flex-col gap-y-2 px-2 mt-4'>
                                      <div className='flex flex-row items-center justify-between flex-grow shrink-0'>
                                        <div className='flex items-center gap-x-[16px]  w-[40%] '>
                                          <span className='flex-shrink whitespace-nowrap overflow-hidden text-ellipsis  font-normal text-dark-black-200 text-[13px]  capitalize'>Max Salary</span>
                                        </div>
                                        <div className='mr-[0px] flex  flex-row items-center flex-grow-0  w-[60%] '>
                                          <div className='ml-3'>
                                            <span className="inline-flex items-center rounded-md bg-gray-50 px-2 py-1 text-xs font-medium text-gray-600 ring-1 ring-inset ring-gray-500/10">
                                              {jobBaseData?.salary_max}
                                            </span>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  }



                                  {/* working type */}
                                  {/* working type */}
                                  {jobBaseData?.salary_duration === null &&
                                    enabled &&
                                    <div className="w-full flex items-center justify-between lg:justify-start py-1 mt-4">
                                      <div className="mr-2 py-1 px-2 font-normal text-dark-black-200 text-[13px] w-[40%] capitalize">
                                        Salary duration
                                      </div>


                                      <div className="w-[60%] flex flex-col  justify-end">
                                        <Listbox value={selectedSalaryType} onChange={handleSalaryTypeChange}>
                                          {({ open }) => (
                                            <div className="relative w-[100%]">
                                              <Listbox.Button
                                                className="w-fit h-[32px] ml-1 flex items-center justify-between gap-2  cursor-pointer capitalize rounded-md bg-white  py-1 px-2 text-left text-[12px] text-[#52555a] font-medium bg-transparent border-solid hover:!border-light-gray-200 border border-white"
                                              >
                                                <div className="flex items-center gap-1 h-[32px]">
                                                  {selectedSalaryType ? (
                                                    <span
                                                      className='truncate text-[13px] leading-4 whitespace-nowrap max-w-[140px] w-full overflow-hidden text-ellipsis text-start'
                                                    >
                                                      {selectedSalaryType.name}
                                                    </span>
                                                  ) : (
                                                    <span className="relative  cursor-pointer rounded-md bg-transparent  flex shrink-0 items-center justify-center  text-[13px] font-medium capitalize mr-[-4px]">
                                                      Select Salary
                                                    </span>
                                                  )}

                                                </div>
                                              </Listbox.Button>

                                              <Transition show={open} leave="transition ease-in duration-100" leaveFrom="opacity-100" leaveTo="opacity-0">
                                                <Listbox.Options className="absolute z-10 w-[150px] left-[0px] mt-1 max-h-60 
        overflow-auto rounded-md bg-white py-1 text-base shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none sm:text-sm">
                                                  {SalaryTypeOptions.map((option) => (
                                                    <Listbox.Option
                                                      key={option.id}
                                                      className={({ active }) =>
                                                        `relative cursor-default select-none py-1.5 pl-3 pr-9 text-[13px] ${active ? 'bg-light-gray-100 text-dark-black-100' : 'text-dark-black-100'
                                                        }`
                                                      }
                                                      value={option}
                                                    >
                                                      {({ selected }) => (
                                                        <div className="flex items-center gap-2">

                                                          <span
                                                            className={`block truncate font-medium text-[13px] leading-4 whitespace-nowrap max-w-[140px] w-full 
                  overflow-hidden text-ellipsis text-start capitalize ${selected ? 'font-semibold' : 'font-normal'}`}
                                                          >
                                                            {option.name}
                                                          </span>
                                                        </div>
                                                      )}
                                                    </Listbox.Option>
                                                  ))}
                                                </Listbox.Options>
                                              </Transition>
                                            </div>
                                          )}
                                        </Listbox>
                                      </div>


                                    </div>
                                  }

                                  {enabled && jobBaseData?.salary_duration &&
                                    <div className="w-full flex items-center justify-between lg:justify-start py-1 mt-2">
                                      <div className="mr-2 py-1 px-2 font-normal text-dark-black-200 text-[13px] w-[40%] capitalize">
                                        Salary duration
                                      </div>


                                      <div className="w-[60%] flex flex-col  justify-end">
                                        <div className="flex items-center gap-1 h-[32px] ml-2">
                                          {selectedSalaryType ? (
                                            <span
                                              className='truncate text-[13px] leading-4 whitespace-nowrap max-w-[140px] text-[#52555a]  w-full overflow-hidden text-ellipsis text-start'
                                            >
                                              {selectedSalaryType.name}
                                            </span>
                                          ) : (
                                            <span className="relative  cursor-pointer rounded-md bg-transparent text-[#52555a] flex shrink-0 items-center justify-center  text-[13px] font-medium capitalize mr-[-4px]">
                                              {jobBaseData?.salary_duration}
                                            </span>
                                          )}

                                        </div>
                                      </div>
                                    </div>
                                  }


                                  {/* currency */}
                                  {jobBaseData?.salary_currency === null &&
                                    enabled &&
                                    <div className="w-full flex items-center justify-between lg:justify-start py-1">
                                      <div className="mr-2 py-1 px-2 font-normal text-dark-black-200 text-[13px] w-[40%] capitalize">
                                        Currency
                                      </div>
                                      <div className="w-[60%] flex flex-col">
                                        <div className="relative">
                                          <button
                                            type="button"
                                            className="w-fit h-[32px] ml-1 flex items-center justify-between gap-2 cursor-pointer capitalize rounded-md bg-white py-1 px-2
    text-left text-[12px] text-[#52555a] font-medium bg-transparent border-solid hover:!border-light-gray-200 border border-white"
                                            onClick={() => setIsOpen(!isOpen)}
                                          >
                                            <span className="mr-2 text-[13px] text-[#374151]">
                                              {selectedCurrency
                                                ? `${selectedCurrency.currency} (${selectedCurrency.code})`
                                                : 'Select currency'}
                                            </span>
                                          </button>

                                          {isOpen && (
                                            <div className="absolute z-10 mt-2 w-full rounded-md shadow-lg bg-white ring-1 ring-black ring-opacity-5 focus:outline-none">
                                              <div className="py-1" role="menu" aria-orientation="vertical" aria-labelledby="options-menu">
                                                <div className="px-4 py-2">
                                                  <input
                                                    type="text"
                                                    className="w-full bg-transparent border-none focus:ring-0 focus:outline-none p-0 text-[14px] text-[#374151]"
                                                    placeholder="Search currency..."
                                                    value={searchQuery}
                                                    onChange={(e) => setSearchQuery(e.target.value)}
                                                  />
                                                </div>
                                                <div className="max-h-[150px] overflow-y-auto overflow-x-hidden">
                                                  {filteredCurrencies.length > 0 ? (
                                                    filteredCurrencies.map((currency, index) => (
                                                      <div
                                                        key={index}
                                                        className={`flex items-center px-4 py-2 cursor-pointer hover:bg-gray-100 ${index === focusedIndex ? 'bg-gray-200' : ''
                                                          }`}
                                                        onClick={() => handleCurrencySelect(currency)}
                                                        ref={(el) => (itemRefs.current[index] = el!)} // Assign ref to each item
                                                      >
                                                        <div className="flex items-center gap-y-[2px]">
                                                          <span className="text-[12px] text-[#374151] font-semibold leading-4 truncate">
                                                            {currency.currency}
                                                          </span>
                                                          <span className="text-[12px] text-[#374151] leading-4 truncate ml-1">{currency.code}</span>
                                                        </div>
                                                      </div>
                                                    ))
                                                  ) : (
                                                    <div className="px-4 py-2 text-gray-500 text-sm">No currencies found</div>
                                                  )}
                                                </div>
                                              </div>
                                            </div>
                                          )}
                                        </div>

                                      </div>
                                    </div>
                                  }


                                  {enabled && jobBaseData?.salary_currency &&
                                    <div className="w-full flex items-center justify-between lg:justify-start py-1">
                                      <div className="mr-2 py-1 px-2 font-normal text-dark-black-200 text-[13px] w-[40%] capitalize">
                                        Currency
                                      </div>
                                      <div className="w-[60%] flex flex-col ml-[11px]">
                                        <span className="relative  cursor-pointer rounded-md bg-transparent text-[#52555a]   text-[13px] font-medium capitalize mr-[-4px]">
                                          {jobBaseData?.salary_currency}
                                        </span>

                                      </div>
                                    </div>
                                  }




                                  {/* save */}
                                  {(edit || enabled) && (
                                    <div className="flex justify-end mt-5">
                                      <button
                                        onClick={handleSalarySave}
                                        className="shrink-0 justify-center rounded-md bg-indigo-600 items-center px-[14px] py-1 text-[13px] font-medium h-[32px] leading-6
          text-white shadow-sm hover:bg-indigo-500 
          focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2
          focus-visible:outline-indigo-600 flex gap-x-1.5"
                                      >
                                        Save
                                        {isSalaryLoading && (
                                          <div className="simple-spinner">
                                            <span></span>
                                          </div>
                                        )}
                                      </button>
                                    </div>
                                  )}


                                </div>
                              </div>
                            </div>
                          </motion.div>
                        )}
                      </AnimatePresence>
                    </div>
                    <div className='w-full h-[1px] bg-[#00000014] my-4'></div>
                    <div className="mb-2  px-[1.2rem]">
                      <div className='flex items-start justify-between w-full'>
                        <a
                          href="#"
                          // onClick={toggleCollapse}
                          className="h-8 items-center rounded-lg bg-transparent  text-gray-600 font-medium text-[0.8125rem] 
                          focus:outline-none px-2 justify-start inline-flex"
                        >

                          Notes



                        </a>
                        <button className=' text-[13px] text-[#266df0]' onClick={handleEditNotes}>
                          Edit
                        </button>
                      </div>
                      <AnimatePresence initial={false}>
                        {!collapsed && (
                          <motion.div
                            initial={{ height: 0, overflow: 'hidden', backgroundColor: 'white' }}
                            animate={{ height: 'auto', overflow: 'inherit', backgroundColor: 'white' }}
                            exit={{ height: 0, overflow: 'hidden', backgroundColor: 'white' }}
                            transition={{ height: { duration: 0.5 }, overflow: 'hidden', backgroundColor: 'red' }}

                          >
                            <div className=" pl-[0px] py-5">
                              <div className='w-full'>

                                <div className="relative">
                                  <label
                                    htmlFor="notes"
                                    className="absolute -top-2 left-2 inline-block bg-white px-1 text-xs font-normal text-dark-black-200 text-[13px]"
                                  >
                                    Private notes
                                  </label>
                                  <textarea
                                    id="notes"
                                    name="notes"
                                    rows={3}
                                    value={notes}
                                    onChange={handleNotesChange}
                                    className={`block w-full  rounded-md border-0 p-2 text-[#52555a] text-[13px] shadow-sm ring-1 
                                             ring-inset ring-gray-300 placeholder:text-[#52555a] font-medium ${editNotes
                                        ? 'focus:ring-2 focus:ring-inset focus:ring-indigo-600'
                                        : 'bg-white pointer-events-none'
                                      } sm:leading-6`}
                                    readOnly={!editNotes}

                                  />
                                </div>


                              </div>
                              {
                                editNotes &&
                                <div className='mt-5 flex justify-end'>
                                  <button
                                    className=" flex gap-2 shrink-0 justify-center rounded-md bg-indigo-600 items-center px-[14px] py-1 text-[13px] font-medium h-[32px] leading-6 text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"

                                    onClick={handleSaveNotes}>
                                    Save
                                    {saveNotesLoading && (
                                      <div className="simple-spinner">
                                        <span></span>
                                      </div>
                                    )}
                                  </button>
                                </div>
                              }
                            </div>
                          </motion.div>
                        )}
                      </AnimatePresence>
                    </div>

                    <div className='w-full h-[1px] bg-[#00000014] my-4'></div>
                    <div className='mb-2 px-[1.2rem]'>
                      <div className="w-full">
                        <div className="w-full flex items-center justify-between lg:justify-start py-1">
                          <div className="mr-2 py-1 px-0 font-normal text-dark-black-200 text-[13px] w-[40%]">
                            Created
                          </div>
                          <div className="relative w-[60%]">
                            <span className="text-[13px] leading-4 whitespace-normal max-w-[140px] w-full text-[#52555a] text-start break-words font-medium">


                              {jobBaseData?.created_at
                                ? new Date(jobBaseData?.created_at).toLocaleDateString('en-GB', {
                                  day: 'numeric',
                                  month: 'long',
                                  year: 'numeric',
                                })
                                : null}

                            </span>
                          </div>
                        </div>
                        <div className="w-full flex items-center justify-between lg:justify-start py-1">
                          <div className="mr-2 py-1 px-0 font-normal text-dark-black-200 text-[13px] w-[40%]">
                            Updated
                          </div>
                          <div className="relative w-[60%]">
                            <span className="text-[13px] leading-4 whitespace-normal max-w-[140px] w-full text-[#52555a] text-start break-words font-medium">

                              {jobBaseData?.updated_at ? getTimeAgo(jobBaseData.updated_at) : null}

                            </span>
                          </div>
                        </div>

                      </div>

                    </div>
                  </div>
                </div>
              </aside>
            </div>
          </div>

        </div>
      </main>
    </div>
  );
};

export default JobLayout;
